// App.jsx

import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import ToastProvider from './components/Toast/ToastProvider';
import Landing from "./pages/Landing.jsx";
import Home from "./pages/Home";
import Login from './pages/Login.jsx';
import AuthLayout from './components/AuthLayout.jsx';
import HeroLayout from './components/HeroLayout.jsx';
import SignupFlow from './components/SignupFlow/SignupFlow.jsx';
import CompleteProfile from './pages/CompleteProfile.jsx';
import FirstFeature from "./pages/FirstFeature.jsx";
import TestAnalysis from "./pages/TestAnalysis.jsx";
import ManageDoctors from "./pages/ManageDoctors.jsx";
import DoctorDashboard from "./pages/DoctorDashboard.jsx";
import ActivateAccount from "./pages/ActivateAccount.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import PeerDashboard from "./pages/PeerDashboard.jsx";
import TestDetails from "./pages/TestDetails.jsx";
import Settings from "./pages/Settings.jsx";
import DataProtection from "./pages/DataProtection.jsx";
import ServiceAgreement from "./pages/ServiceAgreement.jsx";
import RefundPolicy from "./pages/RefundPolicy.jsx";
import AcceptTerms from "./pages/AcceptTerms.jsx";
import Assessment from "./pages/Assessment.jsx";
import SelectFocus from "./pages/SelectFocus.jsx";
import Pricing from "./pages/Pricing.jsx";
import PaymentSuccess from "./pages/PaymentSuccess.jsx";
import Billing from "./pages/Billing.jsx";

// Lazy-loaded so the demo bundle (data + engine) ships in a separate chunk and
// never bloats the main app / front page.
const DemoHome = lazy(() => import('./pages/DemoHome.jsx'));

function App() {
  return (
    <ToastProvider>
      <Router>
        <Routes>
          <Route element={<HeroLayout />}>
            <Route path="/" element={<Landing />} />
            <Route element={<AuthLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignupFlow />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Route>
          </Route>
          <Route path="/legal/data-protection" element={<DataProtection />} />
          <Route path="/legal/service-agreement" element={<ServiceAgreement />} />
          <Route path="/legal/refund-policy" element={<RefundPolicy />} />
          <Route path="/accept-terms" element={<AcceptTerms />} />
          <Route path="/select-focus" element={<SelectFocus />} />
          <Route path="/home" element={<Home />} />
          <Route path="/demo" element={<Suspense fallback={null}><DemoHome /></Suspense>} />
          <Route path="/complete-profile" element={<CompleteProfile />} />
          <Route path="/firstfeature" element={<FirstFeature />} />
          <Route path="/test-analysis" element={<TestAnalysis />} />
          <Route path="/access" element={<ManageDoctors />} />
          <Route path="/doctor" element={<DoctorDashboard />} />
          <Route path="/activate" element={<ActivateAccount />} />
          <Route path="/peer" element={<PeerDashboard />} />
          <Route path="/test-details" element={<TestDetails />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/assessment/:assessmentId" element={<Assessment />} />
        </Routes>
      </Router>
    </ToastProvider>
  )
}
export default App;
